import React, { useState } from 'react';
import style from '../../../css/inquiry.module.css'
import { MemoRegister } from '../../Components/memoRegister';

const StoreInquiry = ({ data, refreshList }) => {

  const [memo, setMemo] = useState(data.memo)

  return (
    <div>
      <div id={style.sub_con_warp}>
        <div className={style.sub11_con01} style={{ paddingTop: 20 }} >
          <div className={style.sub11_con01_left}>
            <div className={style.sub11_text01_1} >
              상호명
            </div>
            <div>
              <input
                className={style.sub11_input01_1}
                name="name"
                value={data.storeName}
                placeholder="상호명을 입력해주세요."
                autoComplete="off"
                maxLength={20}
                readOnly
              />
            </div>
          </div>
          <div className={style.sub11_con01_right}>
            <div className={style.sub11_text01_1}>
              연락처
            </div>
            <div>
              <input
                className={style.sub11_input01_1}
                name="name"
                value={data.user_phone}
                placeholder="예 : 010-0000-0000"
                autoComplete="off"
                maxLength={14}
                readOnly
              />
            </div>
          </div>
        </div>

        <div className={style.sub11_con01} style={{ paddingTop: 20 }}>
          <div className={style.sub11_con01_left} >
            <div className={style.sub11_text01_1}>
              성함
            </div>
            <div>
              <input
                className={style.sub11_input01_1}
                name="name"
                value={data.user_name}
                placeholder="성함을 입력해주세요."
                autoComplete="off"
                maxLength={20}
                readOnly
              />
            </div>
          </div>
          <div className={style.sub11_con01_right} >
            <div className={style.sub11_text01_1}>
              지역
            </div>
            <div>
              <select
                className={style.sub11_input02_1}
                value={data.region.split(" ")[0]}
                disabled
              >
                <option value={data.region.split(" ")[0]}>{data.region.split(" ")[0]}</option>
              </select>
              &nbsp;&nbsp;
              <select
                className={style.sub11_input02_1}
                style={{ width: 160 }}
                value={
                  data.region.split(" ")[2]
                    ? `${data.region.split(" ")[1]} ${data.region.split(" ")[2]}`
                    : (data.region.split(" ")[1] || "-")
                }
                disabled
              >
                <option
                  value={
                    data.region.split(" ")[2]
                      ? `${data.region.split(" ")[1]} ${data.region.split(" ")[2]}`
                      : (data.region.split(" ")[1] || "-")
                  }
                >
                  {
                    data.region.split(" ")[2]
                      ? `${data.region.split(" ")[1]} ${data.region.split(" ")[2]}`
                      : (data.region.split(" ")[1] || "-")
                  }
                </option>
              </select>
            </div>
          </div>
        </div>

        <div className={style.sub11_con02} style={{ paddingTop: 20 }}>
          <div className={style.sub11_text01_1} >
            내용
          </div>
          <textarea
            className={style.custom_textarea_1}
            value={data.contents}
            autoComplete="off"
            maxLength={400}
            disabled
            readOnly
          />
        </div>

        <div className={style.sub11_con02} style={{ paddingTop: 20 }}>
          <div className={style.sub11_text01_1}>
            메모
          </div>
          <textarea
            style={{ height: 100 }}
            className={style.custom_textarea_1}
            value={memo}
            onChange={(e) => setMemo(e.target.value)}
            autoComplete="off"
            maxLength={400}
          />
        </div>

        <MemoRegister idx={data._id} memo={memo} refreshList={refreshList} />
      </div>
    </div >
  );
}

export default StoreInquiry;
